module.exports = __webpack_public_path__ + "img/turbo-features1.dbdf5ae0.png";